export function setupViewportListener(CS: { setIsInSmallviewport: (value: boolean) => void }) {
    const checkViewport = () => {
        //const isSmall = window.innerWidth <= 426;
        const isSmall = window.innerWidth <= 615;
        CS.setIsInSmallviewport(isSmall);
    };

    checkViewport(); // Initial check

    window.addEventListener('resize', checkViewport);

    // Return a cleanup function so you can call it when needed
    return () => {
        window.removeEventListener('resize', checkViewport);
    };
}